export function transformPhoneNumberToReadable(phoneNumber: any) {
  if (!phoneNumber) return phoneNumber;
  const numberToString = phoneNumber.toString();
  if (numberToString.length === 10) {
    return `(${numberToString.slice(0, 3)}) ${numberToString.slice(3, 6)}-${numberToString.slice(6,10)}`;
  } else {
    return numberToString;
  }
}

export function getProductionType(typeId, productionTypes) {
  for (let i = 0; i < productionTypes.length; i++) {
    if (productionTypes[i].id == typeId) {
      return productionTypes[i]['size'];
    }
  }
  return 'Call for details';
}

export function getPackagingType(typeId, packagingTypes) {
  for (let i = 0; i < packagingTypes.length; i++) {
    if (packagingTypes[i].id == typeId) {
      return packagingTypes[i]['label'];
    }
  }
  return 'Call for details';
}

export function getProductType(typeId, productTypes) {
  for (let i = 0; i < productTypes.length; i++) {
    if (productTypes[i].id == typeId) {
      return productTypes[i].type;
    }
  }
  return productTypes[0].type;
}